import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { WIZ_EVENT_TYPE, WDSSelectionMode, WizMathUtils, WIZ_BOOLEAN,
  WIZ_PHYSIC_POSITION, 
  WizDateUtils} from '@wizeoo/akm-core-lib';
import {
  CellCheckedEvent,
  PopUpManager,
  WizAgGrid,
  WizComponentManager,
  WizHgroup,
  WizPopUp,
  WizRoot,
  WizEventManager, WizEvent, WizTranslationManager,
  WizDatasource,
  WizIcon,
  WizVgroup,
  COMPONENTRESOURCES,
  
} from '@wizeoo/akm-component-lib';
import { ColDef, ColGroupDef, Column, GridOptions, CellClickedEvent, CellPosition, CellKeyPressEvent, FullWidthCellKeyPressEvent, RowStyle } from 'ag-grid-community';
import { PopUtils } from '../../../framework/components/pop/pop-utils';
import { AlkEvent } from '../../../framework/events/alk.event';
import { ExcelSheetVo } from '../../../manager/export/excel-sheet.vo';
import { IWidget, IWidgetFilter } from "../../../manager/widgets/i-widget";
import { ALK_EVENT_TYPE, PAGE_EVENT_SYMBOL, WIDGET_ACTION_ORIGIN, WIDGET_GLOBAL_KIND, WIDGET_KIND, WIDGET_STATE } from '../../../model/enums';
import { ViewData } from '../../../model/view.data';
import { FeiVO } from '../../../vo/workingdata/fei.vo';
import { WidgetBasic } from '../base/widget-basic';
import { FastSelectData, PivotFocusedCell, WidgetEngine } from '../../../manager/widgets/widget.engine';
import { PivotCellDeletePop } from './renderers/cells/pivot-cell-delete.pop';
import { PivotCellEditPopData } from '../../../manager/widgets/i-widget';
import { PivotCellMassDeletePop } from './renderers/cells/pivot-cell-mass-delete.pop';
import { PivotCellEditor } from './renderers/cells/pivot-cell.editor';
import { PivotFilterExtendedRenderer } from './renderers/filters/pivot-filter-extended.renderer';
import { PivotHeaderGroupRenderer } from './renderers/header/pivot-headergroup.renderer';
import { PivotBasePop } from './renderers/settings/pivot-base.pop';
import { PivotExtendedPop } from './renderers/settings/pivot-extended.pop';
import { WidgetConfigurationObj, WidgetConfigurationItemObj, Baseline, WidgetExpand, Measure, CrossVisionObj } from '@wizeoo/akm-message-lib';
import { WizColDef } from '../../../manager/workingdata/fei.engine';
import { ClipboardService } from 'ngx-clipboard';
import { BaselineEngine, COMPUTE_MODE, EM_ACTION, FIELD_KIND, FeiKeyDef, LoopResult, MatrixCallParam, WidgetCell, WizConstants } from '@wizeoo/akm-compute-lib';
import { WidgetLine } from '@wizeoo/akm-compute-lib';
import { UpdateEntry, UpdateRequest, CompositeSourcePack, UpdateRevert } from '../../../command/core/sync/sync.service';
import { ConnectVO } from '../../../vo/core/connect.vo';
import { FreedataArgsVO } from '../../../vo/core/freedataargs.vo';
import { MediaReference } from '../../../command/core/attachment/attachment.service';
import { AttachmentService } from '../../../command/core/attachment/attachment.service';
import { ComputePageRenderer } from './renderers/pagination/compute-page';
import { StyleVO } from '../../../vo/workingdata/style.vo';
import { FreedataTileFilterPop } from '../tiles/settings/freedata-tile-filter.pop';
import { zoomPopParams } from '../freedatas/renderers/zoom.pop';
import { clone, cloneDeep, isEqual } from 'lodash-es';

@Component({
  selector: 'pivot-component',
  templateUrl: './pivot.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/** grid (mode flat) ou pivot */
export class Pivot extends WidgetBasic implements AfterViewInit, OnDestroy {
 
  /**
   * constructeur
   * @param elementRef 
   * @param _cdRef 
   */
  constructor(elementRef: ElementRef, cdRef: ChangeDetectorRef, private _clipboardService: ClipboardService) {
    super(elementRef, cdRef);

    this.widgetKind = WIDGET_KIND.PIVOT; // Pivot ou Grid, sera déterminé par pivotMode
    this.widgetGlobalKind = WIDGET_GLOBAL_KIND.BASELINE;
  }

 
  /* ##############################################################################
                  composants spécifiques
  ############################################################################## */

  @ViewChild('agGrid') agGrid: WizAgGrid<WidgetLine>; // grid
  @ViewChild('hgDetailZone', { read: WizHgroup, static: true }) hgDetailZone: WizHgroup; // zone de filtre, pour écouteur sur setFilter

  
  @ViewChild('containerFilter', { read: ViewContainerRef, static: true }) containerFilter: ViewContainerRef; // zone d'ajout des champs de filtre
  @ViewChild('moreFilterIcon') moreFilterIcon: WizIcon;
  @ViewChild('vgMain', { read: WizVgroup, static: true }) vgMain: WizVgroup; // zone de filtre, pour écouteur sur setFilter
  
  /** collection de champs de filtre */
  public filterComponents: ComponentRef<any>[];

  /** composant utilisés par le grid */
  public gridFrameworkComponents = { pivotCellEditor: PivotCellEditor, pivotHeaderGroupRenderer: PivotHeaderGroupRenderer };

  // gestion du rendu avec marque de scenario pour l'icône de suppression
  public get customDeletionRenderer(): Function {
    return this.model.gridAccessors.CELL_DELETION_SCEN_RENDERER;
  }

  // gestion du rendu avec marque de scenario pour l'icône de suppression
  public get customRowGroupRenderer(): Function {
    return this.model.gridAccessors.CELL_GROUP_RENDERER;
  }

  // taille par défaut des entêtes (pour override si ajout des saisies en masse dans les headers)
  public get headerHeight(): number {
    let res: number = ViewData.defaultHeaderHeight;
    if(this.context?.headerHeight) {
      res = this.context.headerHeight;
    }
    if(this.context?.eda  && this.context?.hme) {
      res = 65;
    }

    return res;
  }

  // taille par défaut des lignes 
  public get rowHeight(): number {
    let res: number = ViewData.defaultRowHeight;
    if(this.context?.rowHeight) {
      res = this.context.rowHeight;
    }
    return res;
  }


  public get groupHeaderHeight(): number {
    let res: number = 35;
    return res;
  }


  /* ##############################################################################
                  paramètres spécifiques
  ############################################################################## */

  private revertMainDS: WizDatasource<WidgetLine> = new WizDatasource<WidgetLine>([])
  .setItemCodeField('key')
  .setSelectionMode('single')
  .build();

  /** 
   * construction des éléments reverts sur contruction des colonnes ou des lignes
   * seulement quand lignes et colonnes sont dispos
   */
  private checkRevert(): void {
    if(!this.context?.revert) {
      return;
    }
    if(!this.columns) {
      return;
    }
    if(this.mainDS.getSource()?.length <= 0) {
      return;
    }


    // les fakes Wl pour alimenter rows
    let lines: WidgetLine[] = [];

    this.context?.d?.forEach((wcio: WidgetConfigurationItemObj) => {
      // création d'une ligne par mesure
      let measureFkd: FeiKeyDef = this.fei.keyMap.get(wcio.cod);
      if (measureFkd) {
        const col: any = this.model.feiEngine.buildGridColumn(measureFkd, this, wcio, 'data', false);
        // console.log('col', col);
        let line: WidgetLine = {};
        line.key = col.field;
        line.level = this.fei.visionStepLevel;
        line.uk = col.headerName;
        
        // on mémorise la conf et le fkd sur la ligne pour les futurs calculs et rendus
        line.wcio = wcio;
        // collecte du fkd
        line.fkd = measureFkd;

        lines.push(line);
      }
    });

    let hasRevertTotal:boolean = false;
    // TODO ici ajouter ligne de total (col) si existe sur la mesure en colonne
    this.context?.c?.forEach((wcio: WidgetConfigurationItemObj) => {
      if(wcio.colTot) {
        hasRevertTotal = true;
        // console.log('total revert', wcio);
        // créer un fakeFkd
        // une fake line
        // et ajouter toutes les lignes en children ??
        // ou pas...ou si
      }
    });

    // les colonnes en map
    this.columnsMap = new Map();
    this.columns.forEach((hcol: any) => {// (hcol: WizColDef) => {
      this.columnsMap.set(hcol.fkd.code, hcol);
    });

    // ventilation des packs de lignes dans les colonnes
    this.mainDS.getSource().forEach(wl => {
      let dasCol: WizColDef =  this.columnsMap.get(wl.key);
      if(!!dasCol) {
        dasCol.widgetLine = wl;
      }

      if(hasRevertTotal) {
        let totalCol: WizColDef = this.columnsMap.get('@@TOTAL@@');
        if(!totalCol.widgetLine) {
          totalCol.widgetLine = clone(wl);
        } else {
          totalCol.widgetLine.ch = new Map([...totalCol.widgetLine.ch, ...wl.ch]);
        }
        // totalCol.widgetLine = wl;
      }

    });

    // alimentation de la DS avec une ligne par mesure
    this.revertMainDS.setSource(lines);

  }


  /**
   * construction des colonnes, pour Override dans les toolPivots
   */
  public buildColumns(): void {
    if(this.pivotMode) {
      this.columns = this.model.feiEngine.buildPivotColumns(this, this.context, true);
    } else {
      this.columns = this.model.feiEngine.buildGridColumns(this, this.context, true);
    }

    // et perte des références par colonnes sur les WidgetLines, sinon résultat faussé sur la 1ère colonne
    this.clearLines();

    this.checkRevert(); // vérif mode inversé colonnes / lignes
  }

  // et perte des références par colonnes sur les WidgetLines (chgt filtre global hors structure)
  public clearLines(): void {
    this.mainDS.getSource().forEach((wl: WidgetLine) => {
      wl.linesByColumn = new Map(); // rendus pivots
      wl.rendererMap = null;

      wl.pivotValues = null; // rendu revert
    });
  }

  /**
   * construction des lignes
   */
  public async buildLines(): Promise<void> {
    super.buildLines();
    this.checkRevert(); // vérif mode inversé colonnes / lignes
   }

  /**
   * override de l'accesseur pour passer un éventuel revert
   */
  public get finalDS(): WizDatasource<WidgetLine> {
    // console.log('pivot get mainDS', this.context?.revert, super.mainDS, this._columns);
    if(this.context?.revert) {
      return this.revertMainDS;
    } else {
      return this.mainDS;
    }
  }


  /** définition des colonnes du grid */
  public columns: any[] = null;// (ColDef | ColGroupDef | WizColDef)[] = null;

  /** accesseur sur les colonnes sous forme de map, pour le mode revert. Alimenté lors de la construction des données revert */
  public columnsMap: Map<string, WizColDef> = null;


  /** configuration de l'agGrid */
  gridOptions: GridOptions = {
    onColumnResized: (params) => this.onColumnResize(params), // redimensionnement
    // onSortChanged: (params) => this.onSortChanged(params), // sur modif de tri
    onCellFocused: (params) => this.onCellFocus(params as CellPosition), // sur prise de focus
    stopEditingWhenCellsLoseFocus: true, // 
    suppressRowClickSelection: true, // pas de sélection directe, on gère nous même
    onCellDoubleClicked: (params) => this.onCellDouble(params), // 2x clic pour copy content
    getRowNodeId: (params) => params?.uk, // ce qui définit la clé : la clé unique de widgetLine
    getRowClass: (params) => this.rowClass(params),
    getRowStyle: (params) => this.rowStyle(params),
    onCellKeyPress:(params) => this.trapCrtlZ(params),
  };


  /**
   * piles des updates dans le pivot (max 10)
   */
  private lastUpdatePile: UpdateRevert[] = [];

  /** gestion du ctrl-Z pour inverser le dernier update */
  private trapCrtlZ(trap: CellKeyPressEvent | FullWidthCellKeyPressEvent): void {
    
    
    
    if(trap.event instanceof KeyboardEvent) {
      let kbe: KeyboardEvent = trap.event as KeyboardEvent;
      if(kbe.ctrlKey && kbe.charCode === 26) {
        // console.log('trapCrtlZ', trap.data);
              
        if(this.lastUpdatePile.length > 0) {
          let ue: UpdateRevert = this.lastUpdatePile.pop();
          if(ue) {
            this.crtrZRollback(ue);
          }
        }
      }
    }
  }

  /** mémorisation du focus */
  private onCellFocus(focusedCell: CellPosition): void {
    // prise de la valeur de la cellule cible

    let lastRow: number = this.widget.model.widgetEngine.lastFocusedCell?.focusedCell?.rowIndex;
    let lastCol: string = this.widget.model.widgetEngine.lastFocusedCell?.focusedCell?.column?.getId();
    // console.log('onCellFocus last', lastRow, lastCol);
    // console.log('onCellFocus new', focusedCell?.rowIndex, focusedCell?.column.getId());
    if(lastRow !== focusedCell?.rowIndex || lastCol !== focusedCell?.column?.getId()) {
      this.model.widgetEngine.lastFocusedCell = {pivotUID: this.uid, focusedCell, wl: null, pce: null };
    } else {
      // déjà alimenté par pivotCellEditor
    }

    
  }

  /** accesseur self pour l'alimentation du compo AgGrid */
  get widget(): IWidget {
    return this;
  }

  /** à minima 1 filtre */
  get hasFilter(): boolean {
    return this.filterComponents?.length > 0;
  }

  /** les filtres sont visibles par l'utilisateur */
  get showFilters(): boolean {
    return this.templatingMode || !!this._context?.showF;
  }

  /** afficher les checkboxes de sélection */
  get showRowSelection(): WDSSelectionMode {
    if(!this._context?.shs) { // pas de sélection
      return 'none';
    } else {
      if(!!this._context?.shsu) { // sélection unique
        return 'wiz-single';
      } else {
        return 'multiple';
      }
    }
    // return this._context?.shs ? 'multiple' : 'none';
  }

  /** afficher les checkboxes de suppression */
  get showRowDeletion(): boolean {
    return this._context?.shd && this.model.permissionEngine.feiCanDelete(this.fei);
  }

  /** afficher les groupes de lignes */
  get showRowGroup(): boolean {
    return this.pivotMode && this._context?.pmd;
  }




  /** mode : pivot ou grid simple */
  @Input() public pivotMode: boolean = true;

  ngAfterViewInit() {
    super.ngAfterViewInit();
    // modification du pool de sélection de la DS
    WizEventManager.addListener(this, this.agGrid, WIZ_EVENT_TYPE.SELECTION_CHANGED, this.innerSelectionChange);
    // save d'un formulaire de FD. Possible mise à jour visuelle des Key / filters, e.data = DataPack
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.FREEDATA_UPDATED, this.refreshOnFreedataUpdate);

    // sur retour de datacommit, synchro immédiate des BLVs des grids remote pour éviter les pertes de sync sur numRev
    // marquer l'icone remoteCompute
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.COMPUTE_FAST_SYNC, this.checkRemoteDelta);

  }

  ngOnDestroy() {
    super.ngOnDestroy();
    WizEventManager.removeListener(this, this.agGrid, WIZ_EVENT_TYPE.SELECTION_CHANGED);    
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.FREEDATA_UPDATED);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.COMPUTE_FAST_SYNC);

  }


  /* ##############################################################################
                    alimentation des données FEI / construction du grid
  ############################################################################### */

  /** synchro des valeurs de FDVs sur retour de form Freedata  */
  private refreshOnFreedataUpdate(e: AlkEvent): void {
    this.agGrid.api.refreshCells();
  }

  /**
   * retourne true si un filter / un recalcul endommage la structure des colonnes
   * dans ce cas, il faudra les reconstruire
   * @param le set de filter pour contrôler s'ils sont présents dans les colonnes, OU en args d'une de mes colonnes
   * @returns 
   */
  public damagedColumns(filterSet:  Set<string>): boolean {
    
    let result: boolean = false;
    
    if(filterSet.size > 0 && this.context.c?.length > 0) {
      
      if(filterSet.has(ViewData.FILTER_GENERIC)) { // filtre global, c'est oui, on sort
        result = true;
        return result;
      }
      
      this.context.c.forEach(wcio => {

        let rawCode = wcio.cod.split(ViewData.CONTEXT_SEPARATOR)[0]; // pour prendre le champ SANS le niveau
        if(filterSet.has(rawCode)) {
          result = true;
          // console.log('damagedColumns', rawCode, wcio);
          return; // sortie de boucle
        }

        // recherche éventuelle sur les args de type Object
        let fkd: FeiKeyDef = this.fei.keyMap.get(wcio.cod);
        // console.log('fkd', fkd);
        if(fkd.isFreedata) {
          let args: FreedataArgsVO[] = this.model.freedataEngine.getArgsFromFD(rawCode);
          args?.forEach(arg => {
            if(arg.dataType === FIELD_KIND.OBJECT) {
              // console.log('gotyou', arg);
              if(filterSet.has(arg.datas.split(ViewData.CONTEXT_SEPARATOR)[0])) {
                result = true;
                // console.log('damagedColumns by arg', arg.datas.split(ViewData.CONTEXT_SEPARATOR)[0], wcio);
                return; // sortie de boucle
              }
            }
          });
        }

      }); 
    }

    return result;
  }

  /**
   * actions jouées sur le drawContent, le alterContent, ou en cas de modifs de filtre, de sélection
   * @override
   * @param origin WIDGET_ACTION_ORIGIN pour cibler qui demande
   * @param data l'objet éventuellement porté
   */
  public drawOrRefresh(origin: WIDGET_ACTION_ORIGIN, data?: any): void {

    // console.log('drawOrRefresh', origin);
    let mustBuildFilters: boolean = false; // on doit construire les filtres
    let mustBuildRows: boolean = false; // on doit construire les lignes
    let mustFilter: boolean = false; // on doit appliquer les filtres
    let mustSelect: boolean = false; // on doit jouer la sélection de lignes
    let mustBuildColumns: boolean = false; // on doit construire les colonnes
    let mustRefresh: boolean = false; // simple refresh sur recalcul

    // première création
    if(origin === WIDGET_ACTION_ORIGIN.INIT) {
      // rien à faire
    }
    
    if(origin === WIDGET_ACTION_ORIGIN.READY) { // je me suis dit tout seul que j'étais prêt
      mustBuildFilters = true;
      mustBuildRows = true;
      mustSelect = true;
      mustBuildColumns = true;
    }

    // TODO sur configuration, capter les delta filter, colonnes, fields...

    // TODO TODO détecter une modification structurelle en cas 
    // contextDamaged
    // origine: changement de config
    // et mode pivot, sinon les lignes sont toujours OK
    if(origin === WIDGET_ACTION_ORIGIN.CONFIGURE) {   
      mustBuildFilters = true;
      mustFilter = true;

      this.resetOrderedControls();
      this.resetIntegrityControls();

      if(this.pivotMode) { // en mode pivot, les lignes sont peut-être obsolètes
        mustBuildRows = true;
        mustSelect = true;
      }
      mustBuildColumns = true;
    } 
    
    // modification du filtre... on filtre, et on corrige éventuellement la sélection
    // en cas de champ utilisé en colonne, on reconstruit le grid
    if(origin === WIDGET_ACTION_ORIGIN.FILTERING) {
      // LMA optim
      mustFilter = true;
      // console.log('pivot FILTERING', data);
      // TODO faire moins bourrin
      // on prend les filtres du global (SANS la notion de niveau)
      let globalSet: Set<string> = this.model.widgetEngine.checkFilterSet(this);
      if(this.damagedColumns(globalSet) || this.context.revert) {
        mustBuildColumns = true;
      } else if(this.context.pm && this.context.c?.length > 0) {
        mustBuildColumns = true;
      } else { // sinon, on rince la mémorisation sur les lignes en cas de pivot (forcer recalcul)
        if(this.context.pm || this.context.revert) {
          this.clearLines();
        }
        //mustFilter = true;
      }
    }

    // modification du filtre global ... on filtre, et on corrige éventuellement la sélection
    // en cas de champ utilisé en colonne, on reconstruit le grid
    if(origin === WIDGET_ACTION_ORIGIN.GLOBAL_FILTERING) {

      mustFilter = true;
      // on prend les filtres du global (SANS la notion de niveau)
      let globalSet: Set<string> = this.model.widgetEngine.checkFilterSet(this.model.widgetEngine.checkGlobalFilter());
      if(this.damagedColumns(globalSet) || this.context.revert) {
        mustBuildColumns = true;
      } else if(this.context.pm && this.context.c?.length > 0) {
        mustBuildColumns = true;
      } else { // sinon, on rince la mémorisation sur les lignes en cas de pivot (forcer recalcul)
        if(this.context.pm || this.context.revert) {
          this.clearLines();
        }
        // mustFilter = true;
      }

      // if(this.context.revert) { // mode revert, forcer la perte de mémoire sur les lines.pivotValues
      //   mustBuildRows = true;
      // }

      // TODO TODO trop tôt, non ??
      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.WIDGET_UPDATED, this));
    }

    if(origin === WIDGET_ACTION_ORIGIN.SORT) {   
      if(this.model.widgetEngine.widgetIsCompute(this)) { // modif de tri, reconstruction compute
        WizEventManager.dispatchEvent(this.widget, new AlkEvent(ALK_EVENT_TYPE.COMPUTE_REBUILD, this));
        mustBuildRows = true;
      }  
    } 

    if(origin === WIDGET_ACTION_ORIGIN.GET_PAGE) {   
      if(this.model.widgetEngine.widgetIsCompute(this)) { // demande de chargement d'une page spécifique
        this.buildLines(); // mais sans tout reconstruire
      }  
    } 

    // modification du scenario global ...
    // en cas de champ utilisé en colonne, on reconstruit le grid
    if(origin === WIDGET_ACTION_ORIGIN.GLOBAL_SCENARIO_UPDATE) {
      this.mainDS.refresh(); // on applique le filtre dans tous les cas
      // console.log('pivot GLOBAL_SCENARIO_UPDATE', data);  
      // si le scenar est en colonne, on reconstruit
      let scenInColumns: boolean = false;
      if(this.context.c?.length > 0) {
        this.context.c.forEach(wcio => {
          const rawCode = wcio.cod.split(ViewData.CONTEXT_SEPARATOR)[0];
          if(rawCode === WizConstants.SCEN_KEY_CODE) {
            scenInColumns = true;
          }
        });
        mustBuildColumns = scenInColumns;
      }

      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.WIDGET_UPDATED, this));
    }

    // modification du pool de sélection sur un master
    if(origin === WIDGET_ACTION_ORIGIN.OUTER_SELECT) {
      // console.log('outer select', this.widgetKind, this.fei.uniqueName, this.state);
      if(this.model.widgetEngine.widgetIsCompute(this)) { // modif de master, reconstruction compute
        WizEventManager.dispatchEvent(this.widget, new AlkEvent(ALK_EVENT_TYPE.COMPUTE_REBUILD, this));
      }  
      
      mustBuildRows = true;
      mustSelect = true;
      this.mainDS.refresh(); // on applique le filtre
      
      mustBuildColumns = true;
      mustRefresh = true;
    }

    // fin de calcul d'un FEI requis pour mes calculs
    if(origin === WIDGET_ACTION_ORIGIN.REQUIRED_COMPUTED) {
      mustRefresh = true;
    }


    if(origin === WIDGET_ACTION_ORIGIN.RECOMPUTE) {
      let filterKeyUpdates: Map<Baseline, Set<string>> = data[1];
      let structureDamage: boolean = false;
      if(!!filterKeyUpdates) {
        [...filterKeyUpdates.values()].forEach((keys: Set<string>) => {
          [...keys.values()].forEach(key => {
            this.columns?.forEach((col: WizColDef) => {
              if(col.fkd?.fullCode === key) {
                structureDamage = true;
                return;
              }
            });
            if(structureDamage) {
              return;
            }
            
          });
        });
      }
      
      if(this.pivotMode) { // en mode pivot et mesure utilisée pour les lignes. 
        this.columns?.forEach((col: WizColDef) => {
          if(col?.place === 'row' && col?.fkd?.isMeasure) {
            structureDamage =true;
          }
        })
      }


      // console.log('pivotRecompute', structureDamage);
      if(structureDamage) {
        mustBuildRows = true;
        // console.log('structureDamage');
        mustBuildColumns = true;
      } else {
        let loopResults: Map<FeiVO, LoopResult> = data[0];  
        // gestion multiscen... prendre tous les loopers du même niveau
        if(this.fei.scenario === WizConstants.SCEN_KEY_CODE) {
          [...loopResults.keys()].forEach((fei: FeiVO) => {
            if(fei.visionStepLevel === this.fei.visionStepLevel) {
              if(loopResults.get(fei).created.size > 0 || loopResults.get(fei).deleted.size > 0) {
                mustBuildRows = true;
              } else {
                mustRefresh = true;
              }

            }
          });
        }
        
        // sinon, je regarde si c'est moi
        let loop: LoopResult = loopResults.get(this.fei);
        if(loop?.created.size > 0 || loop?.deleted.size > 0) {
          // console.log('pivot mustBuildRows',this.widgetKind, this.fei.uniqueName, origin, loop);
          // console.log('pivot RECOMPUTE mustBuildRows',this.widgetKind, this.fei.uniqueName, origin, loop);
          mustBuildRows = true;
        } else {
          let pfc: PivotFocusedCell = this.model.widgetEngine.lastFocusedCell;

          if(!!pfc) {  
            // console.log('pivot RECOMPUTE mustRefresh',this.widgetKind, this.fei.uniqueName, origin, loop);
            
            // en cas de pivot ? possible enfants
            let keys: Set<string> = new Set();
            keys.add(pfc.wl?.key);
            if(pfc.wl?.ch) {
              [...pfc.wl.ch.keys()].forEach(s => {
                keys.add(s);
              });
            }
            
            [...loop.updated.keys()].forEach(wl => {
              
              if(keys.has(wl.key)) {
                console.log('update on edited from commit yourDead', wl);
                pfc.pce.yourDead(wl.bl);
                return;
              }
            });
          }

          mustRefresh = true;
        }

        if(loop?.updated.size > 0) { // j'ai une modif sur mon périmètre
          // console.log('datalooper delete', loop.updated);
          [...loop.updated.keys()].forEach(wl => {
            wl.byWidgetStringMap = null;
          });
          
        }

      }
    }

    if(mustBuildFilters) {
      this.buildFilters();
      if(this._context.cm === COMPUTE_MODE.COMPUTE) { // modif de filtre, reconstruction compute
        WizEventManager.dispatchEvent(this.widget, new AlkEvent(ALK_EVENT_TYPE.COMPUTE_REBUILD, this));
        mustBuildRows = true;
      }  
    }

    if(mustFilter) {
      if(this._context.cm === COMPUTE_MODE.COMPUTE) { // modif de filtre, reconstruction compute
        WizEventManager.dispatchEvent(this.widget, new AlkEvent(ALK_EVENT_TYPE.COMPUTE_REBUILD, this));
        mustBuildRows = true;
      }
      this.model.widgetEngine.refreshFilter(data ? data[0]: null); // reconstruction du filtre (symboliques)
      this.mainDS.refresh(); // on applique le filtre

      // potentiellement, on déselectionne
      if(this.mainDS.selectedItems?.length > 0) {
        // contrôle de la sélection. On déselection les éléments masqués
        let realSelected: WidgetLine[] = [];
        this.mainDS.selectedItems.forEach((line: WidgetLine) => {
          if(!!this.mainDS.getItemByKey(line.key)) {
            realSelected.push(line);
          }
        });

        if(realSelected.length === this.mainDS.selectedItems.length) { // tout est OK

        } else {
          this.mainDS.select(realSelected);
          this.onSelectionChanged(); // persistence du contexte de sélection
          this.updateComponentSelection(); // informer les esclaves
        }
      }

      // dispatcher un event. Mes esclaves vont l'intercepter, j'impacte leur pool
      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.WIDGET_UPDATED, this));
    }

    if(mustBuildRows) {
      this.buildLines(); // délégué au WidgetBasic
      this.agGrid.expandAllRows(true); // suppression des lignes masquées
    }

    if(mustSelect) {
      this.feedSelectionFromContext(this._context); // alimentation de la sélection et passage à WIDGET_STATE = SELECTION_COMPLETE
    }

    if(mustBuildColumns) {
      this.buildColumns(); // pour override dans les toolPivots
      if(!!this.context.gps) { // état existant sur les colonnes
       // console.log('mustBuildColumns', this.context.gps);
        this.agGrid.columnApi.setColumnGroupState(this.context.gps); 
      }
      // construction des filtres physiques
      this.buildFilterDrops();
    }

    if(mustRefresh) {
      if(this.pivotMode) { // en mode pivot, il faut oublier les consolidations en cas de agg.compute
        this.mainDS.getSource().forEach(wl => {
          wl.pivotValues = null;
        });
      }
      this.agGrid.api.refreshCells(); // refresh des values modifiées
    }


    // en cas de recréation des lignes (ajout sur override de scenar), repositionnement correct sur retour de commit
    if(this.model.widgetEngine.imLastFocus(this)) {
      let pfc: PivotFocusedCell = this.model.widgetEngine.lastFocusedCell;
      if(!!pfc) {  
        // console.log('pcf', pfc.focusedCell.rowIndex, pfc.focusedCell.column); 
        if(pfc.focusedCell?.rowIndex !== null) {
          if(!this.activeFocus) {
            this.agGrid.api.ensureIndexVisible(pfc.focusedCell.rowIndex);
            this.agGrid.api.setFocusedCell(pfc.focusedCell.rowIndex, pfc.focusedCell.column); 
          }
          
          // this.agGrid.api.ensureIndexVisible(pfc.focusedCell.rowIndex);
          // this.agGrid.api.setFocusedCell(pfc.focusedCell.rowIndex, pfc.focusedCell.column); 
        }
        // console.log('pcf reset', pfc.focusedCell);
        this.model.widgetEngine.lastFocusedCell = null; // et on oublie
      }
    }

    setTimeout(() => { // application du sort du grid (sur sortKeys) Timeout, sinon l'aggrid n'a pas encore construit ses colonnes
      // TODO TODO sur pmd, utiliser un tri par défaut sur les colonnes de row
      
      // contrôle du sort
      if(origin != WIDGET_ACTION_ORIGIN.INIT &&
        origin != WIDGET_ACTION_ORIGIN.RECOMPUTE
      ) {
        this.forcePMDSort();
      }
      
  
      if (!!this.context.gps) { // état de colonnes existant
        this.context.gps.forEach(gp => {
          // console.log('gp', gp);
          if (gp.open) {
            this.agGrid.columnApi.setColumnGroupOpened(gp.groupId, true);
          }
        });
      }

      if (this.pivotMode && this.context.pmd && !!this.context.rowGps) { // état de rows existant
        if(origin !== WIDGET_ACTION_ORIGIN.INIT && origin !== WIDGET_ACTION_ORIGIN.RECOMPUTE) {
          this.feedRowGroups();
        }
        
      }

      if(this.context.stot && this.mainDS?.getWorkedSource()) {//?.length > 0) { // affichage de la ligne de total
        let pinnedBottomData = this.generatePinnedBottomData();
        if(pinnedBottomData) {
          this.agGrid.api.setPinnedBottomRowData([pinnedBottomData]);
        } else {
          this.agGrid.api.setPinnedBottomRowData(null);
        }
        
      }
      // console.log('mustBuildRows', mustBuildRows);
      
      // console.log('origin', origin);
      // console.log('mustBuildRows', mustBuildRows);
      // console.log('mustBuildColumns', mustBuildColumns);
      // console.log('mustFilter', mustFilter);
      // console.log('mustRefresh', mustRefresh);
      // console.log('mustSelect', mustSelect);
      // console.log('this mainDS', this.mainDS);
      // this.agGrid.api.redrawRows(); // test refresh style 1er instance
      // this.cdRef.markForCheck();
    }, 0);
  }


  /**
   * construction 'initiale' des objets graphiques du widget :
   * - sur init véritable
   * - sur modification de la datasource
   * - sur modification de scenario (modifie la DS)
   */
  public drawContent(): void {
    
    let master: IWidget = this.model.widgetEngine.checkFirstMaster(this); // je cherche un master. S'il y en a un, READY n'est pas suffisant
    // si j'ai un master et qu'il n'est pas prêt, on ne fait rien
    if (!!master && master.state !== WIDGET_STATE.SELECTION_COMPLETE) { // j'ai un master, mais il n'est pas prêt
      // console.log('checkFeiState master not ready', this.widgetKind, this.fei.uniqueName);
      return;
    }

    if(this.state >= WIDGET_STATE.READY) { // déjà construit, plus rien a faire
      return;
    }

    this.drawOrRefresh(WIDGET_ACTION_ORIGIN.INIT); // actions communes draw / alter
    super.drawContent(); // pas au début, c'est lui qui dispatch les events
  }

  /**
   * reconstruction des objets graphiques du widget sur changement de structure : 
   * - modification des filtres qui impactent les colonnes
   * - changement de champs en ligne / colonnes / data
   * - changement de filtre
   * - changement de sélection
   * @param origin 
   */
  public alterContent(origin: WIDGET_ACTION_ORIGIN): void {
    this.drawOrRefresh(origin);
    super.alterContent(origin);
  }

  /* ##############################################################################
                mémorisation du tri & des tailles de colonnes
     ############################################################################## */

  /** mémorisation de groupes de colonnes */
  onColumnGroupEvent(e: Event): void {
    const context: WidgetConfigurationObj = this._context;
    context.gps = this.agGrid.columnApi.getColumnGroupState();
    this.updateContext(context);
  }


  /**
   * interception du resize des colonnes pour mémorisation dans le contexte
   * @param params any
   */
  public onColumnResize(params: any): void {
    if (params.source === 'uiColumnDragged' && params.finished) {
      
      const coll: Column[] = params.columns;
      const context: WidgetConfigurationObj = this._context;
      try {
        const candidates: WidgetConfigurationItemObj[] = this.context.r.concat(this.context.d);
        coll.forEach((c: any) => {
          const candidate: WidgetConfigurationItemObj = candidates.filter((item) => item.ord === c.colDef.wcio.ord)[0]; // un seul
          if(!!candidate) { // null sur les tools
            candidate.csiz = c.actualWidth;
            if (!!candidate.cmsiz && candidate.cmsiz > candidate.csiz) {
              candidate.cmsiz = candidate.csiz;
            }
          }
  
        });
  
        this.updateContext(context, true);
      } catch(e: any) { // null sur les tools

      }

    }
  }

  /* ##############################################################################
                    gestion de la popUp de configuration
     ############################################################################## */

  /**
   * @override IWidget : ouverture de la popUp de configuration (clic sur l'icone de conf)
   * override pour passer le mode de rendu grid / pivot
   * le retour est géré dans widget-basic (backFromSettingsPop)
   */
  public showSettingsPop(): void {
    this.settingsPopClassFactory = this.pivotMode ? PivotExtendedPop : PivotBasePop;
    super.showSettingsPop();
  }

  /* ##############################################################################
                    gestion des filtres (composants drop)
     ############################################################################## */

  /**
   * interception de modification de filtre pour déclencher un refresh
   */
  protected innerUpdateFilter(e: AlkEvent): void {
      super.innerUpdateFilter(e);
      this.drawOrRefresh(WIDGET_ACTION_ORIGIN.FILTERING, e.data);
  }

  /** suppression des combos de filtres (avant changement de step, ou sur retour de pop) */
  private clearFilterDrops(): void {
    this.containerFilter?.clear(); // vider le container
    this.filterComponents = []; // on rince la référence aux filtres
    this._needMore = false;
  }

 /** construction des dropdowns de filtre selon le contexte */
  protected buildFilterDrops() {
    this.clearFilterDrops(); // on rince tout
    
    let maxSize: number = this.vgMain?.elementRef?.nativeElement?.offsetWidth;
    let currentSize: number = 0;

    // console.log('size', this.hgDetailZone.elementRef.nativeElement.offsetWidth);

    // construire unique le rendu, pas besoin d'alimenter les collections tant que la drop n'est pas ouverte
    if(this.filters) {
      [...this.filters.values()].forEach((filter: IWidgetFilter) => {
        let compoSize: number = WidgetEngine.getFilterSize(filter);
        if(currentSize + compoSize + 2 <= maxSize - WidgetEngine.ICONS_FILTER_SIZE) {
          const meCompo: ComponentRef<any> = WizComponentManager.instance.addChildTo(
            PivotFilterExtendedRenderer,
            this.containerFilter,
            { instanceProperties: { data: filter } }
          );
          this.filterComponents.push(meCompo);
          currentSize+= compoSize + 7;
        } else {
          this._needMore = true;
        }
        

      });
    }
    this.cdRef.markForCheck();
  }

  private _needMore: boolean = false;
  public get needMore(): boolean {
    return this._needMore;
  }


  public get hasActiveFilter(): boolean {
    let res: boolean = false;
    if(this.filters) {
      [...this.filters.values()].forEach((filter: IWidgetFilter) => {
       if(filter.active) {
        if(!!this.templatingMode || !filter.wcio.filtHide)
        res = true;
       }  
      });
    }
    return res;
  }


  /* ##############################################################################
                    gestion des sélections
     ############################################################################## */

  /**
   * changement de mon pool de sélection... intercepté sur AgGrid
   * on va informer les éventuels esclaves.
   * @param e 
   */
  public innerSelectionChange(e: WizEvent): void {
    if(this.state < WIDGET_STATE.READY) { // pas encore affiché, inutile
      return;
    }
    this.onSelectionChanged(); // persistence du contexte de sélection
    this.updateComponentSelection(); // informer le monde que le master (éventuel) a changé
  }

  /** mémorisation du contexte de sélection */
  public onSelectionChanged(): void {
    if(!this._context) { // inutile si le contexte n'est pas instancié (incexc, vsp)
      return; 
    }
    
    // on fait des paquets de 50 en fonction de l'indice
    // dans ces paquets de 1000, on donne un ordre binaire 2^indice
    // on stocke jusqu'a 50 chiffres, {indice, valeur}
    // exemple, sélection 1, 10, 1001 et 3000
    // 0#1025|10#1|29#1.26765E+30
    const selectMap: Map<number, number> = new Map<number, number>();
    let rankPart: number;
    let binRankPart: number;

    this.mainDS.selectedItems?.forEach((line: WidgetLine) => {
      rankPart = +line.binKey.split(ViewData.CONTEXT_SEPARATOR)[0];
      binRankPart = +line.binKey.split(ViewData.CONTEXT_SEPARATOR)[1];

      if (!selectMap.has(rankPart)) {
        selectMap.set(rankPart, binRankPart);
      } else {
        selectMap.set(rankPart, selectMap.get(rankPart) + binRankPart);
      }
    });

    const selKey: any[] = []; // alimentation des clés dans le contexte
    selectMap.forEach((val: number, key: number) => {
      selKey.push({ k: key, v: val });
    });

    const context: WidgetConfigurationObj = this._context;
    
    // d'abord on vérifie que ça a changé
    let hasUpdate: boolean = !isEqual(context.sel, selKey);
    context.sel = selKey;

    this.updateContext(context, hasUpdate);
    // TODO TODO passer leDrawOr
    this.agGrid.api.redrawRows(); // refresh sur le rendu du grid
  }

  /**
   * alimentation initiale de la sélection
   * @param context 
   */
  public feedSelectionFromContext(context: WidgetConfigurationObj): void {
    const selectPool: WidgetLine[] = [];
    
    if (context.sel?.length > 0) { // pas de context alimenté sur incExc

      // TODO contrôle de cohérence des sélections obsolètes ?
      const selectionKeyMap: Map<number, number> = new Map(context.sel.map((obj) => [+obj.k, +obj.v]));

      let rankPart: number;
      let binRankPart: number;
      this.mainDS.getWorkedSource().forEach((line: WidgetLine) => {
        rankPart = +line.binKey.split(ViewData.CONTEXT_SEPARATOR)[0];
        binRankPart = +line.binKey.split(ViewData.CONTEXT_SEPARATOR)[1];
        if (selectionKeyMap.has(rankPart) && WizMathUtils.wizBitwize(selectionKeyMap.get(rankPart), binRankPart) > 0) {
          selectPool.push(line);
        }
      });
      
      // besoin du timeOut, sinon pas d'application...
      setTimeout(() => {
        this.mainDS.select(selectPool);
        this.mainDS.refresh(); // on rafraichit
        // console.log('applySelection', this.widgetKind, this.fei.uniqueName, this.mainDS.selectedItems);
        this.state = WIDGET_STATE.SELECTION_COMPLETE; // et on passe à l'état sélectionné
        // ma sélection est OK, je signale pour les éventuels esclaves
        // console.log('feedSelectionFromContext', this.widgetKind, this.fei.uniqueName);
        WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.WIDGET_UPDATED, this)); 
      });
    } else {

      // console.log('feedSelectionFromContext', this.fei.uniqueName, this.state);
      this.state = WIDGET_STATE.SELECTION_COMPLETE; // et on passe à l'état sélectionné
      // pas de sélection, on dispatch tout de suite
      WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.WIDGET_UPDATED, this)); 
    }
  }

  /* ##############################################################################
                  Edition
     ############################################################################## */

  /**
  * téléchargement
  * @param params 
  */
  onCellFile(params: any) {

    if (!this.checkBeforeEdit(params, true)) { // seulement si autorisé
      return;
    }
    //##### LMA FILE
    let datakind: string = (params.colDef as WizColDef)?.datakind;
    if(datakind === FIELD_KIND.FILE) {
      if(params.value) {
        try {
          let mediaReference: MediaReference = JSON.parse(params.value);
          if(!!mediaReference) {
            AttachmentService.getInstance().filedownloadForWidget(mediaReference);
          }
        } catch(e: any) {

        }      
      }
      // console.log('cellEdit on file type');
      return; // ici on essaye d'éditer... C'est pas autorisé
    } 

    if(datakind === FIELD_KIND.WORKFLOW) { // pièce jointe sur workflow
      //console.log('bob WORKFLOW', params.value);
      if(params.value) {
        try {
          let rawobj = this.model.workflowEngine.valueFormatter(params);
          let smallMess: any = JSON.parse(rawobj) 
          let mediaReference: MediaReference = smallMess?.media;
          if(!!mediaReference) {
            AttachmentService.getInstance().filedownloadForWidget(mediaReference);
          }
        } catch(e: any) {

        }      
      }
      // console.log('cellEdit on file type');
      return; // ici on essaye d'éditer... C'est pas autorisé
    } 
  }

  /**
   * clic sur le crayon d'édition
   * @param params CellClickedEvent tout le bazard { colDef, data, column, event, value }
   * CellClickedEvent
   */
  onCellEdit(params: any) {
      
    if (!this.checkBeforeEdit(params, true)) { // seulement si autorisé
      return;
    }
    let datakind: string = (params.colDef as WizColDef)?.datakind;
    
    const widget: IWidget = (params.colDef as WizColDef).widget;
    // la ligne base pour cette ligne. Ce n'est pas forcément la bonne ligne pour la colonne...
    const line: WidgetLine = params.data;
    // le pool de lignes qui correspondent à ma cellule
    const pack: WidgetLine[] = widget.pivotMode ? widget.getPool(line, params.column) : [line];
    const wizColDef: WizColDef = params.colDef as any as WizColDef; // définition de la colonne
    const fkd: FeiKeyDef = wizColDef.fkd;

    // ### construction du label  
    let rowKeys: string[] = []; // champs en lignes
    let lbl: string; 
    widget.context.r.forEach((wcio: WidgetConfigurationItemObj) => {
      lbl = BaselineEngine.getLabel(this.fei, pack[0], wcio.cod, WizConstants.FIELD_LABEL)
      if(lbl) {
        rowKeys.push(lbl);
      }
    });
    
    const colKeys: string[] = []; // champs en colonne
    let firstParent: any = params.column['parent'];
    while (firstParent && firstParent.groupId) {
      // split, car les colonnes présentes plusieurs fois sont suffixés _xx
      let lbl = BaselineEngine.getLabel(this.fei, pack[0], firstParent.groupId.split('_')[0].split(ViewData.KEY_SEPARATOR)[0], WizConstants.FIELD_LABEL);
      if(lbl) {
        colKeys.push(lbl);
      };
      firstParent = firstParent.parent;
    }
    if(colKeys.length > 0) {
      rowKeys = rowKeys.concat(colKeys.reverse());
    }

    const isIn: Set<string> = new Set(); // unicité du champ dans le titre, sinon trop long
    const correctKeyArr: string[] = [];
    rowKeys.forEach(s => {
      if(!isIn.has(s)) {
        isIn.add(s);
        correctKeyArr.push(s);
      }
    });
    let title: string = correctKeyArr.join(' - ').substring(0, 200);

    // prise de la valeur non transformée
    // let realValue: string = BaselineEngine.getRawKeyOrValue(this.fei, params.data, fkd.fullCode);
    // console.log("realValue", realValue, params.value);

    //##### LMA WORKFLOW
    if(datakind === FIELD_KIND.WORKFLOW) {
      // titre propre
      title = this.model.localeEngine.translate(fkd.measure.label, fkd.measure.code).trim();
    }
    //##### FIN LMA WORKFLOW



    let datas: PivotCellEditPopData = { 
      kind: WIDGET_GLOBAL_KIND.BASELINE,
      title, 
      label: null, 
      value: params.value, // realValue, //
      column: params.column,
      settings: fkd.measure?.settings || null,
      fkd, line, pack, widget, 
      isFilterKey: fkd.isFilterKey,
      pointer: params.event as PointerEvent,
      callback: this.backFromEditPop.bind(this)};

    /** ouverture de la pop d'édition en masse */
    // dispatch de l'event, sert possiblement pour sélection rapide sur le master, synchro des esclaves
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.SHOWPOP, datas));

  }

  /**
   * callBack de retour de la popUp d'édition en masse
   * @param data PivotCellEditPopData, avec UpdateRequest
   */
  public backFromEditPop(data: PivotCellEditPopData): void {
    
    // console.log('backFromEditPop', data);
    // la demande
    const updateRequest: UpdateRequest = data.updates;
    // les entrées d'update générés
    let updates: UpdateEntry[] = [];
    let update: UpdateEntry;
    
    if (updateRequest?.lines?.length > 0) {
      
      if(updateRequest.doSplit) {
        updates = this.model.dataEngine.SplitValue(updateRequest);
      } else {   
        updateRequest.lines.forEach((line: WidgetLine) => { // bridage selon maxCommit
            
          update = this.model.dataEngine.generateUpdate(updateRequest.fei as any, line, updateRequest.fkd, updateRequest.value);
          updates.push(update);
        });
      }

      let clean: UpdateEntry[] = [];
      updates.forEach(ue => {
        // on applique les restrictions "D'avant"
        let keyPartMap: Map<string, string> = new Map();
        // keyPartMap.set(ue.field, ue.oldValue);
        // console.log('ue', ue);
        let wl: WidgetLine = this.fei.getWidgetLineForKey(this.fei.scenario, ue.baseline?.key);

        let fkd: FeiKeyDef = this.fei.keyMap.get(ue.field);
        let meas: Measure = fkd?.measure;
        if(fkd.isFilterKey) {
          clean.push(ue); // pas de contrôle sur les filterKeys
        } else {
          if(wl && meas && !!meas.editRestrict) {
            const res : boolean = this.model.widgetEngine.computeEditRestrict(this.fei, meas, [wl], true, keyPartMap);
            // const res = this.checkEditAvailable(this.fei, meas, linePack, true);

            if (res) { // contrôle d'édition sur la mesure (avant fastMode)
              wl.rendererMap?.delete(data.column.getInstanceId()); // on supprimer le rendu
              clean.push(ue);
            } else {
              this.model.dataEngine.rollBackUpdate(ue);
              // console.log('restrict & rollback', ue);
            }
          } else {
            wl.rendererMap?.delete(data.column.getInstanceId());
            clean.push(ue);
            // console.log('no line or measure', wl, meas);
          }

          if(wl && meas && !!meas.linkedRef) { // gestion du crossDomain
            let oneMorOrMany: UpdateEntry[] =  this.model.widgetEngine.resolveCrossed(this.fei, updateRequest, update, updates, wl, fkd);
            if(!!oneMorOrMany) {    
              oneMorOrMany.forEach(omom => {
                console.log('omom', omom);
                clean.push(omom);
              });
            }

          }

        }
        


      });


      // console.log('backFromEditPop cell', data);
            // line?.rendererMap?.delete(cell.);
      // console.log('clean',updateRequest, clean);
      // contrôle de cohérence avant envoi
      this.postControlBeforeCommit(updateRequest, clean);
    }
  }

 /**
   * mise à jour de la valeur d'une cellule en édition directe
   * possible saisie en masse. Le mode sera dans ce cas déterminé par mem (massEditMode)
   *
   * @param cell contient le node (la ligne), la WidgetLine porteuse, la colDef, la oldValue et la newValue
   */
  public updateCell(cell: any): boolean {
      
    // console.log('updateCell', cell.newValue, cell.oldValue);
    if (cell.newValue !== cell.oldValue) {
      // la WidgetLine de base pour cette ligne. Ce n'est pas forcément la bonne ligne pour la colonne...
      const line: WidgetLine = cell.data;
      // le pool de lignes qui correspondent à ma cellule (mode multi-colonnes)
      const pack: WidgetLine[] = this.pivotMode ? this.getPool(line, cell.column) : [line];
      const wizColDef: WizColDef = cell.column.colDef as any as WizColDef; // définition de la colonne
      const fkd: FeiKeyDef = wizColDef.fkd;
      // la demande
      const updateRequest: UpdateRequest = {
        fei: this.fei, 
        line: line,
        lines: pack, 
        operation: EM_ACTION.UPDATE,
        fkd: fkd,
        value: cell.newValue,
        doSplit: false
      };
    
      // les updates
      let updates: UpdateEntry[] = []; 
    
      // demande de ventilation (mem === 3), split uniquement sur les numbers...
      if(this.context!.mem === 3 && fkd.isMeasure && (fkd.datakind === FIELD_KIND.INT || fkd.datakind === FIELD_KIND.NUMBER)) { 
        updates = this.model.dataEngine.SplitValue(updateRequest);
      } else { // clone de la valeur ou demande simple
        
        let update: UpdateEntry;
        pack.forEach((item: WidgetLine) => {
          update = this.model.dataEngine.generateUpdate(this.fei, item, fkd, cell.newValue);
          if (update.oldValue !== update.newValue) {
            updates.push(update); // l'update met à jour la baselineValue
            item.rendererMap?.delete(cell.column.getInstanceId()); // on supprimer le rendu
            // console.log('update cell', cell);
            // line?.rendererMap?.delete(cell.);

            if(fkd.isMeasure && !!fkd.measure.linkedRef) { // gestion du crossDomain
              let oneMorOrMany: UpdateEntry[] =  this.model.widgetEngine.resolveCrossed(this.fei, updateRequest, update, updates, item, fkd);
              if(!!oneMorOrMany) {    
              oneMorOrMany.forEach(omom => {
                console.log('omom', omom);
                updates.push(omom);
              });
            }
              // console.log('updateCell', update);
            }

          }
        });
      }

      if (updates?.length > 0) { // va s'occuper du rollback éventuel en cas d'incohérence
        // contrôle de cohérence avant envoi
        this.postControlBeforeCommit(updateRequest, updates);
      }
    }
    return true;
  }



  /**
   * Handler sur le clic d'une colonne de type boolean (checkbox)
   * @param params CellCheckedEvent { colDef, data, column, event, value }
   * @returns 
   */
  public onCellChecked(params: CellCheckedEvent): void {
    
    if (this._context.eda === false) { // widget en lecture seule
      return;
    }
    
    if (!this.checkEditRestrictFromCell(params, false)) { // contrôle d'édition sur la mesure
      return;
    }

    const widget: IWidget = (params.colDef as WizColDef).widget;
    // la ligne base pour cette ligne. Ce n'est pas forcément la bonne ligne pour la colonne...
    const line: WidgetLine = params.data;
    // le pool de lignes qui correspondent à ma cellule
    const pack: WidgetLine[] = widget.pivotMode ? widget.getPool(line, params.column) : [line];
    const wizColDef: WizColDef = params.colDef as any as WizColDef; // définition de la colonne
    const fkd: FeiKeyDef = wizColDef.fkd;

    // forcer le passage en 2 états, le undefined est juste un état d'affichage en pivot
    if (params.newValue === WIZ_BOOLEAN.UNKNOWN) {
      params.newValue = WIZ_BOOLEAN.FALSE;
    }

    if (!this.fei.canUpdateItem(pack)) { // aucun droit trouvé
      return;
    }

    // la demande
    const updateRequest: UpdateRequest = {
      fei: this.fei, 
      line: line,
      lines: pack, 
      operation: EM_ACTION.UPDATE,
      fkd: fkd,
      value: params.newValue,
      doSplit: false
    };

    // les updates
    let updates: UpdateEntry[] = []; 
    let update: UpdateEntry;
    pack.forEach((item: WidgetLine) => {
      update = this.model.dataEngine.generateUpdate(this.fei, item, fkd, params.newValue);
      if (update.oldValue !== update.newValue) {
        updates.push(update); // l'update met à jour la baselineValue

        if(item && fkd.measure && !!fkd.measure.linkedRef) { // gestion du crossDomain
            let oneMorOrMany: UpdateEntry[] = this.model.widgetEngine.resolveCrossed(this.fei, updateRequest, update, updates, item, fkd);
            if(!!oneMorOrMany) {    
              oneMorOrMany.forEach(omom => {
                updates.push(omom);
              });
            }
        }
      }
    });

    if (updates?.length > 0) { // va s'occuper du rollback éventuel en cas d'incohérence
      // contrôle de cohérence avant envoi
      this.postControlBeforeCommit(updateRequest, updates);
    }
  }

  /** fin de traitement d'update, contrôle d'intégrité avant envoi
    * @param updateRequest porteuse des widgetLines sources
    * @param updates porteur des demandes de modifs, pour rollback éventuel 
    */
  public postControlBeforeCommit(updateRequest: UpdateRequest, updates: UpdateEntry[], noCommit: boolean = false): void {
    
    // en cas de trigger de type matrice, appel asynchrone
    // contrôle des triggers
    let more: UpdateEntry[] = this.checkTriggers(updates);
    
    // et jouer leurs linkedRef
    if(more?.length > 0) {
      more.forEach((upd: UpdateEntry) => {
        // console.log('postControlBeforeCommit', upd);
        // prise du FKD pour contrôle des linkedRef
        let fkd: FeiKeyDef = this.fei.keyMap.get(upd.field);
        let item: WidgetLine = this.fei.getWidgetLineForKey(upd.baseline.scen, upd.baseline.key);
        if(!!fkd.measure?.linkedRef) { // si oui, prise de la Widgetline
          
          let oneMorOrMany: UpdateEntry[] = this.model.widgetEngine.resolveCrossed(this.fei, updateRequest, upd, more, item, fkd);
          if(!!oneMorOrMany) {    
            oneMorOrMany.forEach(omom => {
              // console.log('crossed bound', omom);
              updates.push(omom);
            });
          }
        }

    });
    }



    // il existe des appels de matrice, il faut refaire un passage après le chargement
    if(this.fei.model.cellMatrixEngine.dexiePromises.size > 0) {
      // console.log('matrix trigger', this.fei.model.cellMatrixEngine.dexiePromises);
      this.postControlWithMatrix(updateRequest, updates, noCommit);
    } else {
      this.postControlNextStep(updateRequest, updates, noCommit);
    }
  }

  /**
   * il existe des valeurs issues des matrices dans le trigger
   * il faut recalculer et régénerer les updates
   * @param updateRequest 
   * @param updates 
   */
  public postControlWithMatrix(updateRequest: UpdateRequest, updates: UpdateEntry[], noCommit: boolean = false): void {
    // console.log('postControlWithMatrix', updates);
    Promise.all(this.fei.model.cellMatrixEngine.dexiePromises.values()).then((matrix: MatrixCallParam[]) => {
      matrix.forEach((mat:MatrixCallParam) => {
        // console.log('computeWithMatrix', mat);
        let cell: WidgetCell = mat.widgetCell;
        let res: any = null;
        if(mat.result?.length > 0) {
          // console.log('matrix', matrix);
          let rawResult: string = mat.result[0][mat.targetColumn];
          // correction des formats numérique
          if(rawResult !== null && rawResult!==undefined) { 
            if(this.fei.model.dataEngine.datakindIsNumeric(mat.datakind)) {
              res = Number(rawResult.replaceAll(',','.').replaceAll(' ',''));
            } else {
              res = rawResult;
            }
            // console.log('matrix', mat.datakind, res);
          }
        }
        this.fei.model.cellMatrixEngine.dexieResolved.set(cell, res);
        // mise à jour de l'entrée
        updates.forEach(ue => {
          if(ue.sourceTrigger === cell.m && ue.baseline.key === cell.k) {
            BaselineEngine.baselineSetValue(ue.baseline, ue.field, res);
            this.model.cellMatrixEngine.addCell(ue.baseline.level, ue.baseline.key, ue.baseline.scen, ue.field, res);
            // console.log('updates', ue.field, ue.oldValue, res);
            ue.newValue = res;
            // et on peut supprimer l'entrée
            this.fei.model.cellMatrixEngine.dexieResolved.delete(cell);
            // console.log('trig ue', ue);
          }
        });

      });

      // on rince les promesses
      this.fei.model.cellMatrixEngine.dexiePromises.clear();
      this.postControlNextStep(updateRequest, updates, noCommit);
    });
  }


  private postControlNextStep(updateRequest: UpdateRequest, updates: UpdateEntry[], noCommit: boolean = false): void {
    let readyForCommit: boolean = true; // en cas de mesure, on contrôle la cohérence

    // console.log('postControlNextStep', updates);
    readyForCommit = this.checkBeforeCommit(updateRequest, updates);

    if(readyForCommit && !noCommit) { // tout est OK

      // mémorisation de la demande dans la pile de modifs pour éventuel revert
      this.lastUpdatePile.push({updateRequest, updates})
      if(this.lastUpdatePile.length > 10) {
        this.lastUpdatePile.splice(0,this.lastUpdatePile.length - 10); // pas plus de 10
      }
      // console.log('lastUpdatePile', this.lastUpdatePile);
      const csp: CompositeSourcePack =  { updates };

      if(!!updateRequest.freedata) {
        csp.freedataManagement = true;
        csp.freedata = updateRequest.freedata;
      }

    // on applique le refresh sur la cellule
    const focusedCell = this.agGrid.api.getFocusedCell();
    if (focusedCell) {
      this.agGrid.api.refreshCells({
        rowNodes: [this.agGrid.api.getDisplayedRowAtIndex(focusedCell.rowIndex)],
        columns: [focusedCell.column.getId()],
        force: true
      });
    }

      this.model.compositeEngine.compositeCommit(csp);
    }
  }


  /** 
   * demande de suppression d'une ligne
   * @param params tout le bazard { colDef, data, column, event, value }
   * @returns 
   */
  public onItemDeleted(params: CellClickedEvent): void {
    
    if (this._context.eda === false) { // widget en lecture seule
      return;
    }

    // la ligne base pour cette ligne. Ce n'est pas forcément la bonne ligne pour la colonne...
    const line: WidgetLine = params.data;
    // le pool de lignes qui correspondent à ma cellule
    const pack: WidgetLine[] = this.pivotMode ? this.getPool(line, params.column) : [line];
    // gestion des droits en cas de vsp
    if (!this.fei.canDeleteItem(pack)) { 
      return;
    }

    if(this.integrityControls?.length > 0) {
      let integrityCrc: boolean = this.integrityCheck(this.fei, this.integrityControls, pack);
      if(!integrityCrc) { // KO, pas autorisé
        return;
      }
    }
    

    // pour suppression unitaire ou en masse
    let popFactory: any = pack.length > 1 ? PivotCellMassDeletePop :PivotCellDeletePop; 

    let datas: PivotCellEditPopData = { 
      kind: this.widgetGlobalKind, pointer: null,
      title: null, 
      label: null, 
      value: null, 
      column: params.column,
      fkd: null, line, pack, widget: this, callback: this.backFromDeletePop.bind(this)};

    const deletePop: WizPopUp = new WizPopUp(popFactory, false, false, null, popFactory.width, popFactory.height, datas);
    const pos: DOMRect = (params.event.target as Element).getBoundingClientRect();
    const bestXY: [number, number] = PopUtils.setPopCoord(pos, deletePop, WIZ_PHYSIC_POSITION.BOTTOM_RIGHT);
    const x: string = bestXY[0] + 'px';
    const y: string = bestXY[1] + 'px';
    const targetPosition: any = { left: x, top: y }; // position physique
    deletePop.customPosition = targetPosition;

    if (PopUpManager.exist(deletePop)) { // suppression de l'instance existante
      deletePop.hide();
    }
    deletePop.show();
  }

  /**
   * retour de popUp de demande de suppression
   * @param data PivotCellEditPopData
   */
  protected backFromDeletePop(data: PivotCellEditPopData): void {  
    
    const updateRequest: UpdateRequest = data.updates;
    // on va générer des updateEntry de type delete
    let updates: UpdateEntry[] = [];
    let update: UpdateEntry;
    let deletecascade: boolean = this.context.shrd === true;
    if (updateRequest?.lines?.length > 0) {
      updateRequest.lines.forEach((line: WidgetLine) => { // bridage selon maxCommit
        line.bl.operation = EM_ACTION.DELETE;
        // TODO TODO vérifier
        update = this.model.dataEngine.generateUpdate(updateRequest.fei as any, line, null, null);
        if(deletecascade) {
          update.baseline.deleteCascade = true;
          update.baseline.cascadeDeep = this.model.dataEngine.getMaxDeep(updateRequest.fei.visionStepLevel);
        }
        updates.push(update);
      });
      
      const csp: CompositeSourcePack =  { updates };
      this.model.compositeEngine.compositeCommit(csp);
    }
  }

  /* ##############################################################################
                    Tools
     ############################################################################## */

  /** demande d'export depuis le bouton */
  public exportDatas(kind?: string): void {
    if(!kind || kind === 'excel') {
      this.model.excelExportEngine.exportAsExcel('allkeyme', this);
    } else {
      this.model.excelExportEngine.exportAsPdf('allkeyme', this, this.elementRef, null, '1000px');
    }
  }

  /**
   * drop d'un fichier excel (excelExportEngine)
   * @param sheet 
   */
  public fileDrop(sheet: ExcelSheetVo): void {
    this.model.excelExportEngine.excelDrop(sheet, this);
  } 

  /** 
   * copie vers le clipboard sur 2x clic 
   * et prise de sélection rapide
  */
  private onCellDouble(params: any): void {
    
    let mayEdit: boolean = this.checkBeforeEdit(params, true);  
    

    let ev: AlkEvent = null;
    if (!!mayEdit) { // cellule éditable, pas de 2x clic
      return;
    } 

    // affichage possible si panneau latéral (mémorisation de l'event)
    let fsd: FastSelectData = {fei: this.fei, kind: this.widgetGlobalKind, data: params.data, 
      targetSlave: this.context.targetSlave,
      event: params.event
    };
    ev = new AlkEvent(ALK_EVENT_TYPE.PIVOT_DOUBLE, fsd);
    ViewData.LAST_DOUBLE_EVENT = clone(ev); // pour replay dans la popUp de droite (si ouverture)
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.PANEL_SUBMIT, fsd));
  


    // this._clipboardService.copy(params.value); // copie vers clipboard
    
    if(!!this._context?.shs) { // affichage des colonnes de sélection
      this.mainDS.select([params.data]);
      this.onSelectionChanged(); // persistence du contexte de sélection
      this.updateComponentSelection(); // informer les esclaves
    }
    
    // console.log('onCellDouble', params.data.key, mayEdit, params.value);

    
    // dispatch de l'event, sert possiblement pour sélection rapide sur le master, synchro des esclaves
    if(ev) {
      WizEventManager.dispatchEvent(WizRoot.root(), ev);
    }
    
  }

  /**
     * Handler sur le clic d'une colonne de type action (connect)
   * @param param0 
   * @returns 
   */
  onAction(params: CellClickedEvent) {
    if (this._context.eda === false) { // widget en lecture seule
      return;
    }
    const line: WidgetLine = params.data; // ligne source
    const cnx: ConnectVO = params.value;
    this.model.connectEngine.doArgActionExt(cnx?.code, this, [line]);
  }


  
  /**
   * modif des droits. pour gestion du rendu des headers
   * @param context 
   */
  public override rightsUpdate(context: WidgetConfigurationObj): void {
    // console.log('rightsUpdate in pivot', context, this.headerHeight);
    this.agGrid?.api.setHeaderHeight(this.headerHeight);
  }


  /**
   * gestion du style des lignes de sous-totaux
   * @deprecated
   * @param params la ligne
   * @returns 
   */
  public rowClass(params: any)  {
    // console.log('rowStyle', params);
    if(!this.context?.pmd) { // pas d'affichage du détail, pas de rendu de consolidation
      return null;
    }
    // try {
    //   if(params.data?.isSubTotalLine) { // seulement si des enfants (ligne de cumul)
    //     // TODO BMR selon params 
    //     // console.log('params isSubTotalLine', params.data?.key, params.data?.subTotalLevel);
    //     if(params.data.subTotalLevel === 1) {
    //       return 'ag-row-pinned1';
    //     } else if(params.data.subTotalLevel === 2) {
    //       return 'ag-row-pinned2';
    //     } 
        
    //     return 'ag-row-pinned';
    //   }
    // } catch(e: any) {

    // }
    return null; 
  }
 
  /**
   * construction de la ligne de total général
   * @returns 
   */
  generatePinnedBottomData(): WidgetLine{
    
    // si pas pivot, prendre mainDs.workedSource
    // si pivot et pas de détail, prendre mainDS.workedSource
    // si pivot et détail, prendre uniquement les mainDS.workedSource.isSubTotalLine
    // let resultColl: WidgetLine[] = [];
    let result: WidgetLine = null;
    this.mainDS.getWorkedSource().forEach((wl: WidgetLine) => {
      
      if(this.pivotMode) {
        if(wl.isSubTotalLine) {
          [...wl.ch.values()].forEach(child =>{
            // resultColl.push(child);
            if(!result) {
              result = BaselineEngine.buildMasterLine('@@TOTAL@@', child);
            } else {
              let scenKeyKey = [child.scen, child.key].join(WizConstants.FD_PARTS_SEPARATOR);
              result.ch.set(scenKeyKey, child);
            }
          });
        }
      } else { // mode simple
        // resultColl.push(wl);
        if(!result) {
          result = BaselineEngine.buildMasterLine('@@TOTAL@@', wl);
        } else {
          let scenKeyKey = [wl.scen, wl.key].join(WizConstants.FD_PARTS_SEPARATOR);
          result.ch.set(scenKeyKey, wl);
        }
      }

    });

    if(result) {
      result.isSubTotalLine = false;
      result.isTotalLine = true;
    }
    // console.log('total row', result)
    return result;
  }


  /**
   * collecte de tous les enfants d'une ligne, en récursif
   * @param line 
   * @param pool 
   */
  private getExpandPool(lines: WidgetLine[], pool: WidgetLine[]): void {
    lines.forEach(line => {
      if(!!line.ch) {
        this.getExpandPool([...line.ch?.values()], pool); 
      }
      pool.push(line);
    })
  }

  /**
   * clic sur expand/ collapse des groupes
   * @param e 
   */
  onRowGroupEvent(e: any): void {
    // console.log('onRowGroupEvent', e);
    let wl: WidgetLine = e.data;
    // console.log('onRowGroupEvent', e);
    wl.subTotalExpended = !wl.subTotalExpended;
    // console.log('wl', wl.key);
    if(!this.agGrid.hiddenRows) {
      this.agGrid.hiddenRows = new Map();
    }
    
    let pool: WidgetLine[] = [];
    this.getExpandPool([...wl.ch?.values()], pool);
    pool.forEach(child => {

    //[...wl.ch?.values()].forEach(child => {
      if(wl.subTotalExpended) {
        this.agGrid.hiddenRows.delete(child);
      } else {
        this.agGrid.hiddenRows.set(child, wl);
      }
    });

    
    this.agGrid.refreshHiddenRows();
    this.agGrid.api.redrawRows({rowNodes: e.node}); // on refresh la ligne de cumul
    // repositionnement
    this.jumpBackToCell();

    // console.log('good expand', this.agGrid.hiddenRows);

    if(wl.subTotalLevel > 0) {
      this.saveRowGroups(wl, pool); // mémorisation du contexte
    } else {
      this.saveRowGroups(); // mémorisation du contexte
    }

  }

  /**
   * clic sur le header des rowGroups pour collapseAll
   */
  private collapseAll(): void {
    
    this.agGrid.hiddenRows = new Map();
    this.mainDS.getWorkedSource().forEach((wl: WidgetLine) => {
      if(wl.isSubTotalLine) {  
        wl.subTotalExpended = false;
        [...wl.ch?.values()].forEach(child => {
          this.agGrid.hiddenRows.set(child, wl);
        });
      }
    });
    this.agGrid.refreshHiddenRows();
    this.agGrid.api.redrawRows(); // on refresh la ligne de cumul
  }

  /**
   * action sur le header de la colonne de rowGroup
   * @param e expand, true, sinon false pour collapse
   */
  collapseOrExpandGroups(e: WizEvent): void {
    // console.log('collapseOrExpandGroups', e);
    
    // console.log('onRowGroupHeaderEvent', e);
    if(e.value === true) {
      this.agGrid.expandAllRows();
    } else {
      this.collapseAll();
    }

    this.saveRowGroups(); // mémorisation du contexte
  }


  saveRowGroups(line?: WidgetLine, pool?: WidgetLine[]): void {
    let rowCollapsed: Map<string, WidgetExpand> = new Map();
    
    if(!!line) { // mode gigogne
      this.context.rowGps?.forEach(we => { // reprise de l'existant
        rowCollapsed.set(we.groupId, we);
      });

      rowCollapsed.set(line.key, {groupId: line.key, open: line.subTotalExpended });
      pool.forEach(swl => {
        if(swl.isSubTotalLine) {
          rowCollapsed.set(swl.key, {groupId: swl.key, open: line.subTotalExpended ? true: false });
        }       
      });

    } else {
      [...this.agGrid.hiddenRows?.values() || []].forEach((wl: WidgetLine) => {
        rowCollapsed.set(wl.key, {groupId: wl.key, open: false })
      });
    }

    this.context.rowGps = [...rowCollapsed.values()];
    this.updateContext(this.context);
    // console.log('updateContext groups', this.context.rowGps);
  }


  // sur init, alimentation des groupes de lignes
  private feedRowGroups(): void {
    // TODO TODO seulement si modif de context vs rowGps
    // console.log('feedRowGroups', this.context.rowGps);
    if (this.context.rowGps?.length > 0) {
      
      // les lignes déjà gérée par maman ou grand-mère
      // let allreadyDone: Set<string> = new Set();

      // prise de la conf du context
      let rowSet: Map<string, WidgetExpand> = new Map();
      this.context.rowGps.forEach(we => {
        rowSet.set(we.groupId, we);
      });

      if(!this.agGrid.hiddenRows) {
        this.agGrid.hiddenRows = new Map();
      }

      this.mainDS.getWorkedSource().forEach((wl: WidgetLine) => {
        if( //!allreadyDone.has(wl.key) && // pas déjà gérée par un ancêtre
         wl.isSubTotalLine && // seulement les lignes de cumul
         rowSet.has(wl.key) && //avec une conf 
         !rowSet.get(wl.key).open) { // et fermée
          wl.subTotalExpended = false;
          // allreadyDone.add(wl.key);
          [...wl.ch?.values()].forEach(child => { // todo get pool ??
            // allreadyDone.add(wl.key);
            this.agGrid.hiddenRows.set(child, wl);
          });
        }
      });

      this.agGrid.refreshHiddenRows();
      this.agGrid.api.redrawRows(); // on refresh la ligne de cumul

    }
  }

  /**
   * consolidation du resultat en mode revert
   * @override
   * @param params 
   * @returns 
   */
  public override revertValueAccessor(params: any): any {
    let result: string = ''; // retour, pas de null
    const line: WidgetLine = params.data; // ligne source (la mesure en fait)
    const fkd: FeiKeyDef = params.colDef.fkd; // fkd (une mesure fake, c'est une fait un code FDV ou REVERT_MESURE_COLUMN)

    if(fkd.code === ViewData.REVERT_MESURE_COLUMN) { // c'est la 1ère colonne, elle porte le nom des mesures
      result = line.uk;
    } else {
      
      // reconstruction de la mesure
      let aggMethod = line.key.split(ViewData.KEY_SEPARATOR)[1];
      
      // collecte du fkd sur le fei (c'est lui qui porte la mesure)
      let measureFkd: FeiKeyDef = line.fkd;

      

      // prise de la vraie ligne
      let srcCol: WizColDef =  this.columnsMap?.get(fkd.code);
      let realLine: WidgetLine = srcCol?.widgetLine;
      //console.log('revert', fkd.code, realLine);
      if(realLine && measureFkd) { // pas forcément sur modif de filtre
        // let pool: WidgetLine[] = [...realLine.ch?.values() || []];
        let pool: WidgetLine[] = [...realLine.ch?.values()].filter((item) => this.mainFilterFunction(item)) || [];

        result = this.model.aggregateEngine.revertAggregate(aggMethod, this, pool, measureFkd, params); 
      }
    }

    return result;
  }

  /**
   * formatage du resultat en mode revert
   * @override
   * @param params 
   * @returns 
   */
  public override revertFormatterValueAccessor(params: any): any {
    let result: string = params?.value || ''; // retour, pas de null
    const line: WidgetLine = params.data; // ligne source (la mesure en fait)
    const fkd: FeiKeyDef = params.colDef.fkd; // fkd (une mesure fake, c'est une fait un code FDV ou REVERT_MESURE_COLUMN)

    if(!line) {
      return result;
    }

    if(fkd.code === ViewData.REVERT_MESURE_COLUMN) { // c'est la 1ère colonne, elle porte le nom des mesures
      return result;
    } 
      

    // reconstruction de la mesure
    let measureKey: string = line.key.split(ViewData.KEY_SEPARATOR)[0];
    let aggMethod = line.key.split(ViewData.KEY_SEPARATOR)[1];
    
    // collecte du fkd (de la mesure)
    let measureFkd: FeiKeyDef = line.fkd;

    if(!measureFkd || !line.wcio) {
      return result;
    }

    let format: string = line.wcio.fmt || measureFkd.defaultFormat;

    // prise du format
    result = this.model.formatEngine.applyFormat(params.value, measureFkd.datakind, format, aggMethod);   
    return result;
  }

  public checkRemoteDelta(e: AlkEvent): void {
    this.cdRef.markForCheck();
  }

  /**
   * rendu de l'icone compute. Orange si désynchro
   */
  public get computeDelta(): any {
    if(this.model.dataEngine.deltaRev(this.fei)) {
      return 'smallMe orange buttonmode-class';
    } else {
      return 'smallMe basicColor buttonmode-class';
    }
  }

  /** date de mise à jour du grid compute */
  public get timeLabel(): string {
    let mess: string = ''; 
    if(this.fei && this.computeMode) {
      let time: number = this.fei.computeTime;
      if(time) {
       //  let baseStr: string = WizTranslationManager.getInstance().translateKey('$.common.lastupdate.$');

        let datePart: string = time.toString().substring(0, 8);
        let dateStr = WizDateUtils.numberToLocalizedString(Number(datePart));

        let timePart: string = time.toString().substring(8, 12);
        let timeStr: string = WizDateUtils.dateToString(WizDateUtils.hourToDate(timePart), WizDateUtils.HOUR_FORMAT_MASK);
        mess = [ dateStr, timeStr].join(' ');
      }
    }
    return mess;
  }


  /** compteur de page / d'items */
  public get countLabel(): string {
    let mess: string = ''; 
    if(this.fei && this.computeMode) {
      let pageSize: number = this.context.cms || 100;
      let totalPage: number = this.fei.totalSizes?.get(this.uid) || 0;
      let nbPages: number = Math.ceil(totalPage/ pageSize);
      let currentPage: number = this.context?.cmp || 1;
      if(currentPage > nbPages) {
        currentPage = nbPages;
      }
      mess = currentPage + ' / ' + nbPages;
      mess += ' ' + WizTranslationManager.getInstance().translateKey('$.widget.pages.$');

    } else {
      if(this.mainDS) {
        mess = this.mainDS.getWorkedSource().length + ' / ' + this.mainDS.getSource().length;
        mess += ' ' + WizTranslationManager.getInstance().translateKey('$.widget.elements.$');
      }
    }


    return mess;
  }

  /* ##############################################################################
        construction de la pagination
     ############################################################################## */

  // zone d'injection
  @ViewChild('pageContainer', { read: ViewContainerRef, static: true }) pageContainer: ViewContainerRef;

  // mode compute actif
  public get computeMode(): boolean {
    let result: boolean = this.model.widgetEngine?.widgetIsCompute(this);
    // console.log('computeMode: ', result );
    return result;
  }

  /**
   * construction de la pagination sur retour de calcul
   */
  public drawPages(e: AlkEvent = null): void {
    
    this.pageContainer.clear();

    // besoin de navigation si + 10
    // activer ou pas les symboles
    // cibler sur page en cours
    // ... pour faire joli

    // on affiche pas plus que ça
    let maxPagesToShow: number = 9;
    // la moitié pour centrer sur la page en cours
    let half: number = Math.floor((maxPagesToShow - 1)/2);

    // combien de pages au total
    let maxPage: number = this.model.widgetEngine.widgetMaxPages(this);
    
    // la page en cours
    let currentPage: number = this.model.widgetEngine.widgetCurrentPage(this);

    // par défaut on cible la page en cours au milieu
    let idx: number = currentPage > half ? currentPage - half : 1;
    let nbDraw: number = 0;

    // on dessine à gauche si trop de pages (sauf si on est au début)
    if(maxPage > maxPagesToShow && currentPage > 1) {
      WizComponentManager.instance.addChildTo(ComputePageRenderer, this.pageContainer, {
        instanceProperties: {
          widget: this,
          symbol: PAGE_EVENT_SYMBOL.FIRST
        }
      });
      WizComponentManager.instance.addChildTo(ComputePageRenderer, this.pageContainer, {
        instanceProperties: {
          widget: this,
          symbol: PAGE_EVENT_SYMBOL.BACK
        }
      });
    }

    // les vraies pages
    while (idx <= maxPage && nbDraw < maxPagesToShow) {
      WizComponentManager.instance.addChildTo(ComputePageRenderer, this.pageContainer, {
        instanceProperties: {
          widget: this,
          page: idx,
        }
      });
      nbDraw++;
      idx++;
    }
    
    // on dessine à droite si trop de pages (sauf si on est à la fin)
    if(maxPage > maxPagesToShow && currentPage !== maxPage) {
      WizComponentManager.instance.addChildTo(ComputePageRenderer, this.pageContainer, {
        instanceProperties: {
          widget: this,
          symbol: PAGE_EVENT_SYMBOL.NEXT
        }
      });
      WizComponentManager.instance.addChildTo(ComputePageRenderer, this.pageContainer, {
        instanceProperties: {
          widget: this,
          symbol: PAGE_EVENT_SYMBOL.LAST
        }
      });
    }
  }

  /**
   * synchro des remotes sur dataCommit pour éviter les pertes de numRev en attendant le calcul compute
   * @param e 
   */
  public computeFastSync(e: AlkEvent): void {
    // TODO TODO seulement si je suis concerné ??
    // console.log('computeFastSync', this.fei?.uniqueName);
    this.agGrid?.api.refreshCells(); // refresh des values modifiées
  }

  /**
   * sur expand / close / modif, retour à proximité de la cellule d'origine
   */
  private jumpBackToCell(): void {  
      let pfc: PivotFocusedCell = this.model.widgetEngine.lastFocusedCell;
      if(!!pfc) {  // retour sur la cellule 
        // console.log('pcf', pfc.focusedCell.rowIndex, pfc.focusedCell.column); 
        if(pfc.focusedCell?.rowIndex !== null) {
          this.agGrid.api.ensureIndexVisible(pfc.focusedCell.rowIndex);
          this.agGrid.api.setFocusedCell(pfc.focusedCell.rowIndex, pfc.focusedCell.column); 
        }
        // console.log('pcf reset', pfc.focusedCell);
        this.model.widgetEngine.lastFocusedCell = null; // et on oublie
      }
  }

  private crtrZRollback(ur: UpdateRevert): void {
    
    let oldV: string;
    let newV: string;

    ur.updates.forEach(ue => {
      oldV = ue.oldValue;
      newV = ue.newValue;
      ue.oldValue = newV;
      ue.newValue = oldV;
   
      // maj de la baseline
      // prise de la ligne "fraiche" dans la widgetLine
      let realBL: Baseline;
      ur.updateRequest.lines.forEach(wl => {
        if(wl.bl.key === ue.baseline.key) {
          realBL = wl.bl;
        }
      });

      if(realBL) { // devrait toujours être vrai
        // maj de la matrice
        this.model.cellMatrixEngine.addCell(ue.baseline.level, ue.baseline.key, ue.baseline.scen, ue.field, ue.newValue);

        ue.baselineValueOperation = EM_ACTION.UPDATE;
        // maj dans la baseline... inutile ?
        ue.baseline.values[ue.field].valor = ue.newValue;
        ue.baseline.values[ue.field].version = realBL.values[ue.field].version;
        ue.baseline.values[ue.field].revisionNumber = realBL.values[ue.field].revisionNumber;
        
        // maj dans la BLV
        ue.baselineValue.valor = ue.newValue;
        ue.baselineValue.version = realBL.values[ue.field].version;
        ue.baselineValue.revisionNumber = realBL.values[ue.field].revisionNumber;
        ue.baselineOperation = EM_ACTION.UPDATE;
      }

    });
    
    // console.log('crtrZRollback', ur);
    const csp: CompositeSourcePack =  { updates:ur.updates };
    this.model.compositeEngine.compositeCommit(csp);
  }

  // TODO alimenter. Supprimer sur modif structure (configure ?)
  private styleByLevel: Map<number, StyleVO>;

  public rowStyle(params: any): RowStyle  {
    if(!this.context?.pmd) { // pas d'affichage du détail, pas de rendu de consolidation
      return null;
    }
    try {
      if(params.data?.isSubTotalLine) { // seulement si des enfants (ligne de cumul)
        
        // console.log('level', params.data.subTotalLevel);
        let styleCode = this.context.r[params.data.subTotalLevel - 1].masterRowStyle;
        if(!!styleCode) {
          let parts: string[]= styleCode.split(ViewData.KEY_SEPARATOR);
          let real: StyleVO = this.model.styleEngine.getStyle(parts[0], parts[1]);

          if(real) {
            let result = this.model.widgetEngine.computeConsoRowStyle(this.fei,real, params);
            // let pad: number = ((params.data as WidgetLine).subTotalLevel -1)*5;
            // result['padding-left'] = pad + 'px';
            return result;
          }
        }

        // ici, retour de base (pas de style)
        switch(params.data.subTotalLevel) {
          case 1:
            return { 
              'backgroundColor': '#c9c9c9',
              'font-weight': 'bold',
            };
          case 2:
            return { 
              'backgroundColor': '#d9d9d9',
              'font-weight': 'bold',          
            };
          default: 
            return { 
              'backgroundColor': '#e9e9e9',
              'font-weight': 'bold',
            };
        }
      }
    } catch(e: any) {

    }
    return null; 
  }

  /** clic sur un média, zoom */
  onImage(event: CellClickedEvent) {
    let colDef: WizColDef = event.colDef as WizColDef;
    let data: WidgetLine = event.data;
    if(colDef.datakind === FIELD_KIND.BINARY || colDef.datakind === FIELD_KIND.BINARY_MULTI) {
      let realValue = event.value;
      // if(colDef.fkd?.isKey || colDef.fkd?.isFilterKey) {
      //   realValue = this.keyFormatterAccessor(event); // le blobID
      // } else {
      //   realValue = this.valueFormatterAccessor(event); // le blobID
      // }
      
      if(realValue) {
        this.seeImage(realValue);
      }
    }

  }

  private zoomPop: WizPopUp; // la popUp de zoom sur les images
  /**
   * zoom sur une image
   */
  public seeImage(blobid:string): void {
          let params: zoomPopParams = {
            zoomPop: this.zoomPop,
            blobid: blobid,
            // arg: this.data.arg,
            //fdvDS: this.data.ds
          }
        
        PopUtils.showZoomPop(params);
  }


 
  public clearAllFilter(): void {

    // ne pas rincer les filtres masqués
    if(this.filters) { // on rince les IWidgetFilter
      [...this.filters.values()].forEach((filter: IWidgetFilter) => {
        if(!!this.templatingMode || !filter.wcio.filtHide) {
          filter.values = null;
          filter.regex = null;
          filter.active = false;
        }
        
      });
    }
    
    // on rince le contexte
    this.context.f.forEach(wcio => {
      if(!!this.templatingMode || !wcio.filtHide) {
        wcio.sel = null;
      wcio.filtExp = null;
      }
    });

    // on rince les instances
    this.filterComponents.forEach(pfer => {
      if(!!this.templatingMode || !pfer.instance.context.filtHide) {
        pfer.instance.clearFilter(false); // clear sans dispatch
      }
      
    });

    // persistence uniquement hors du template, sinon, c'est délégué
    if (!this.templatingMode) { 
        this._saveContext();
    } else { // mise à jour du template, pas du contexte
        this.settings = this.context;
        WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.WIDGET_SET_SETTINGS, this));
    }     

    this.drawOrRefresh(WIDGET_ACTION_ORIGIN.FILTERING);// et application du filtre
  }
  
  /**
   * détection du resize pour redessiner les filtres
   * @override
   * @param width 
   * @param height 
   */
  public onResize(width, height): void {
    if(this._previousSize && this._previousSize.width !== width) {
      this.buildFilterDrops();
    }
    super.onResize(width, height);
  }

  /**
   * pop de liste des filtres
   */
  public moreFilterPop(): void {

    const pop: WizPopUp = new WizPopUp(
      FreedataTileFilterPop,
      false,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      FreedataTileFilterPop.width,
      FreedataTileFilterPop.height,
    );

    const pos: DOMRect = this.moreFilterIcon.elementRef.nativeElement.getBoundingClientRect();
    const bestXY: [number, number] = PopUtils.setPopCoord(pos, pop, WIZ_PHYSIC_POSITION.BOTTOM_RIGHT);
    const x: string = bestXY[0] + 'px';
    const y: string = bestXY[1] + 'px';
    const targetPosition: any = { left: x, top: y }; // position physique
    pop.customPosition = targetPosition;
   
    pop.setCallback(this.backFromFilterPop.bind(this));

    pop.datas = [this,this.filters];

    if (PopUpManager.exist(pop)) { // suppression de l'instance existante
      pop.hide();
    }
    pop.show();
  }

  private backFromFilterPop(updates: Map<string, IWidgetFilter>): void {
 
    if(updates?.size > 0) { // on reconstruit les filtres
      
      // les contextes de filtre
      const filterMap: Map<string, WidgetConfigurationItemObj> = new Map(this.context.f.map((item) => [item.cod + item.fdvf, item]));

      [...updates.keys()].forEach(k => {
          let up: IWidgetFilter = updates.get(k);
          let existWcio = filterMap.get(k);
          if (up.active) { // seulement si le filtre est actif
            if(up.fkd?.datakind === FIELD_KIND.LIST) {
              existWcio.sel = up.values?.size > 0 ? [...up.values].join(ViewData.DOUBLEKEY_SEPARATOR) : null;
            } else {
              existWcio.sel = up.values?.size > 0 ? [...up.values].join(ViewData.KEY_SEPARATOR) : null;
            }
            existWcio.filtExp = up.regex;
            
          } else {
            existWcio.sel = null; // null car '' signifie qu'il y a quand même un filtre (=> filtre sur les valeurs vides)
            existWcio.filtExp = null;
          }
      });

      this.buildFilters();
      this.buildFilterDrops();
      
      // persistence uniquement hors du template, sinon, c'est délégué
      if (!this.templatingMode) { 
          this._saveContext();
      } else { // mise à jour du template, pas du contexte
          this.settings = this.context;
          WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.WIDGET_SET_SETTINGS, this));
      }  

      // et on filtre
      this.drawOrRefresh(WIDGET_ACTION_ORIGIN.FILTERING);// et application du filtre
    }
  }

  public EXCEL: any = COMPONENTRESOURCES.EXCEL;
  public get exportEnableXLS(): boolean {
    // console.log('exportXls', this.context.expXLS);
    return !this.context?.expXLS;
  }

  public get hasSlave(): boolean {
    return !!this.context?.targetSlave;
  }

  public showSlave(e:MouseEvent): void {
    // affichage possible si panneau latéral (mémorisation de l'event)
    let fsd: FastSelectData = {fei: this.fei, kind: this.widgetGlobalKind, data: null, 
      targetSlave: this.context.targetSlave,
      event: e
    };

    let ev: AlkEvent = new AlkEvent(ALK_EVENT_TYPE.PIVOT_DOUBLE, fsd);
    ViewData.LAST_DOUBLE_EVENT = clone(ev);

    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.PANEL_SUBMIT, fsd));
  } 

}






























































